"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Tue Jul 17 2018
 */

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * Converts attributes of GlobalSettings
 * @author RV
 */


var GlobalSettingsConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(GlobalSettingsConverter, _DataObjectConverter_);

  function GlobalSettingsConverter() {
    _classCallCheck(this, GlobalSettingsConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(GlobalSettingsConverter).apply(this, arguments));
  }

  return GlobalSettingsConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.GlobalSettingsConverter = GlobalSettingsConverter;